import { render, staticRenderFns } from "./recorditem.vue?vue&type=template&id=01abbc92"
import script from "./recorditem.vue?vue&type=script&lang=js"
export * from "./recorditem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports